// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#000","menuActiveText":"#1890ff","subMenuActiveText":"#1890ff","menuBg":"#fff","menuHover":"#0000","subMenuBg":"#f4f4f4","subMenuHover":"#f4f4f4","sideBarWidth":"210px"};